import React from 'react';
import { Skeleton } from '@material-ui/lab';
import { Paper, Grid } from '@material-ui/core';

const SHeaderLoader = ({ buttons = [88, 108] }) => {
  return (
    <Paper square style={{ padding: '8px 16px' }}>
      <Grid alignItems='center' container spacing={1}>
        <Grid item xs={9}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Skeleton variant="rect" animation='wave' width={24} height={24} />
          </div>
        </Grid>
        <Grid item xs={3}>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            {buttons.map((width, index) => (
              <Skeleton key={index} variant="rect" animation='wave' width={width} height={30} style={{ borderRadius: 4 }} />
            ))}
          </div>
        </Grid>
      </Grid>
    </Paper>
  );
};
export default SHeaderLoader;
